<img
    [src]="downloadUrl | async"
    alt="Video Thumbnail"
    class="admin-video-card-thumbnail"
    loading="lazy"
    onerror="src='../../../assets/images/course-thumbnails/default.jpg'"
>
